import _ from 'lodash';
import { SUPPORTED_LANGUAGES } from 'arbitrip-common/translation/const';

const toggleZendeskMessenger = (action) => {
    if (_.isFunction(window.zE)) {
        window.zE('messenger', action);
    }
};

function loadZendeskChat(profile, options) {
    const currentLanguage = options.language;

    const keys = profile?.company?.zendesk_widget_keys;
    const zendeskKey = currentLanguage === SUPPORTED_LANGUAGES.HE ? keys?.he : keys?.en;

    const script = document.createElement('script');
    script.addEventListener('load', function () {
        if (!window.zE) return;

        // Workaround for managing widget launch button visibility in a Mobile project
        if (options.zendesk_settings?.hide_default_launcher) {
            window.zE('messenger', 'hide');

            window.zE('messenger:on', 'close', function () {
                setTimeout(() => {
                    if (window.zE) {
                        window.zE('messenger:set', 'zIndex', -1);
                    }
                }, 500);
            });
        }

        window.zE('messenger:set', 'locale', currentLanguage);

        // Anonymous users are not logged into the chat (they have no Zendesk JWT).
        const isLoggedIn = _.get(profile, 'isLoggedIn', false);
        if (isLoggedIn) {
            setTimeout(() => {
                if (window.zE) {
                    _zendeskLogin(profile);
                }
            }, 1000);
        }
    });

    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`;
    script.id = 'ze-snippet';
    document.head.appendChild(script);
}

function _zendeskLogin(profile) {
    if (!window.zE) return console.error('Error loading Zendesk');
    
    window.zE('messenger', 'loginUser', 
        function jwtCallback(callback) {
            const token = profile?.settings?.zendesk_jwt_token;
            callback(token);
            },
         function loginCallback() {
            if (profile?.tier) {
                window.zE("messenger:set", "conversationTags", [`Matmid-Tier-${profile.tier.toString()}`]);
            }
        }
    );
}

export { loadZendeskChat, toggleZendeskMessenger };
